const transportModes = [
    {value: 'CAR', label: 'Auto', urlLabel: 'auto', trackingLabel: 'Car'},
    {value: 'PUBLIC', label: 'Öffentlicher Verkehr', urlLabel: 'oeffentlicher-verkehr', trackingLabel: 'Public Transport'},
    {value: 'FOOT', label: 'Fußgänger', urlLabel: 'fussgaenger', trackingLabel: 'Pedestrian'},
    {value: 'BIKE', label: 'Fahrrad', urlLabel: 'fahrrad', trackingLabel: 'Bike'},
    {value: 'MOTORCYCLE', label: 'Motorrad', urlLabel: 'motorrad', trackingLabel: 'Motorcycle'},
    {value: 'PARK_AND_RIDE', label: 'Park & Ride', urlLabel: 'park-ride', trackingLabel: 'Park and Ride'},
    {value: 'BIKE_AND_RIDE', label: 'Bike & Ride', urlLabel: 'bike-ride', trackingLabel: 'Bike and Ride'},
    {value: 'CAMPER', label: 'Wohnmobil', urlLabel: 'wohnmobil', trackingLabel: 'Camper'},
    {value: 'TRAILER', label: 'Gespann', urlLabel: 'gespann', trackingLabel: 'Trailer'},
    // {value: 'SHARING', label: 'Sharing', urlLabel: 'sharing', trackingLabel: 'Sharing'},
    // {value: 'BIKE_SHARING', label: 'Bike Sharing', urlLabel: 'bike-sharing', trackingLabel: 'Bike Sharing'},
    // {value: 'CAR_TRAIN', label: 'Autoreisezug', urlLabel: 'autoreisezug', trackingLabel: 'Autoreisezug'},
];
// TODO: for commented modes check tracking labels
export default transportModes;